// src/App.js
import React from "react";
import "./App.css";

function App() {
  return (
    <div className="main-container">
      <div className="content">
        <h1 className="flicker">Void Protocol</h1>

        <pre className="ascii-art">
          {`
            ______              
       .d$$$******$$$$c.        
    .d$P"            "$$c      
   $$$$$.           .$$$*$.    
 .$$ 4$L*$$.     .$$Pd$  '$b   
 $F   *$. "$$e.e$$" 4$F   ^$b  
d$     $$   z$$$e   $$     '$. 
$P     '$L$$P\` \`"$$d$"      $$ 
$$     e$$F       4$$b.     $$ 
$b  .$$" $$      .$$ "4$b.  $$ 
$$e$P"    $b     d$'    "$$c$F 
'$P$$$$$$$$$$$$$$$$$$$$$$$$$$  
 "$c.      4$.  $$       .$$   
  ^$$.      $$ d$"      d$P    
    "$$c.   '$b$F    .d$P"     
      \`4$$$c.$$$..e$$P"        
          \`^^^^^^^ \`           
          `}
        </pre>

        <div className="tagline">
          
          <span className="typewriter">"An enigmatic gateway to the unknown, where algorithms decide the fate of digital realms.<br />
          Enter the void and witness the balance of control and chaos."</span>
        </div>

        <a href ="https://t.me/VoidProtocolSol" target="_blank"><button className="enter-btn">Enter the Void</button></a>
      </div>
    </div>
  );
}

export default App;
